import React from 'react';
import oneImage from './one.png';
import twoImage from './2.png';
import threeImage from './3.png';
import fourImage from './4.png';
import fiveImage from './5.png';

const Portfolio = () => {
  const projects = [
    {
      title: 'Skid-Mounted ETP',
      description:
        'Complete effluent treatment plant for pharmaceutical wastewater with advanced biological and chemical treatment processes.',
      image: oneImage,
      features: ['BOD Removal', 'COD Removal', 'Zero Liquid Discharge', 'Automated Control'],
    },
    {
      title: 'Modular Industry ETPs',
      description:
        'Advanced odor removal and treatment system for industry effluents with water recycling capabilities.',
      image: twoImage,
      features: ['Color Removal', 'Water Recovery', 'Energy Efficient', 'Compact Design'],
    },
    {
      title: 'Food Processing ETP',
      description:
        'Customized ETP and STP for food processing industries.',
      image: threeImage,
      features: ['Odor Control', 'Low Sludge Production', 'Easy Maintenance', 'Cost Effective'],
    },
    {
      title: 'Chemical Industry - ZLD System',
      description:
        'State-of-the-art Zero Liquid Discharge system for chemical manufacturing with complete water recovery.',
      image: fourImage,
      features: ['100% Water Recovery', 'Salt Recovery', 'Energy Optimization', 'Smart Monitoring'],
    },
  ];

  return (
    <div className="min-h-screen">
      <div className="animated-bg"></div>

      {/* Hero Section */}
      <section className="pt-24 pb-14 px-4" data-testid="portfolio-hero">
        <div className="max-w-6xl mx-auto text-center">
          <div className="fade-in">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Our <span className="neon-text">Portfolio</span>
            </h1>
            <p className="text-base text-white/80 max-w-2xl mx-auto">
              Discover few of our successful projects across diverse industries
            </p>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="pb-14 px-4" data-testid="projects-grid">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {projects.map((project, index) => (
              <div
                key={index}
                className="glass-card rounded-2xl overflow-hidden"
                data-testid={`project-card-${index}`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-48 object-contain transform hover:scale-110 transition-transform duration-600"
                  />
                  <div className="absolute top-3 right-3 glass px-3 py-1 rounded-full">
                    <span className="text-white text-xs font-semibold">{project.capacity}</span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-white mb-1">{project.title}</h3>
                  <p className="text-purple-300 text-sm mb-3">{project.client}</p>
                  <p className="text-sm text-white/80 mb-4 leading-relaxed">{project.description}</p>
                  <div className="grid grid-cols-2 gap-2">
                    {project.features.map((feature, idx) => (
                      <div
                        key={idx}
                        className="glass px-2 py-1.5 rounded-md text-xs text-white/90"
                        data-testid={`project-${index}-feature-${idx}`}
                      >
                        <span className="mr-1">&#10003;</span>
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-14 px-4" data-testid="portfolio-stats">
        <div className="max-w-6xl mx-auto">
          <div className="glass-card rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-8 text-center">
              Project <span className="neon-text">Statistics</span>
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center" data-testid="stat-capacity">
                <div className="text-2xl md:text-3xl font-bold neon-text mb-1">100+</div>
                <p className="text-sm text-white/80">KLD Total Capacity</p>
              </div>
              <div className="text-center" data-testid="stat-industries">
                <div className="text-2xl md:text-3xl font-bold neon-text mb-1">25+</div>
                <p className="text-sm text-white/80">Industries Served</p>
              </div>
              <div className="text-center" data-testid="stat-success">
                <div className="text-2xl md:text-3xl font-bold neon-text mb-1">100%</div>
                <p className="text-sm text-white/80">Success Rate</p>
              </div>
              <div className="text-center" data-testid="stat-uptime">
                <div className="text-2xl md:text-3xl font-bold neon-text mb-1">99.5%</div>
                <p className="text-sm text-white/80">Uptime Guarantee</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="glass py-6 px-4 mt-14">
        <div className="max-w-6xl mx-auto text-center text-sm text-white/80">
          <p>&copy; 2025 Research and Solution. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Portfolio;
